import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, message, InputNumber } from "antd";
import API from "../../api"; // Import the API instance

const WarehouseDrawer = ({ open, setOpen, data, isEdit, onSubmit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  // Set initial values when the data or form changes (for editing)
  useEffect(() => {
    if (open) {
      if (isEdit && data) {
        form.setFieldsValue(data); // Pre-populate form when in edit mode
      } else {
        form.resetFields(); // Reset form for add mode
      }
    }
  }, [open, isEdit, data, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      let response;
      if (isEdit) {
        response = await API.put(`/warehouse/${data._id}`, values);
        message.success("Warehouse updated successfully!");
        onSubmit({ ...values, id: data.id });
      } else {
        response = await API.post(`/warehouse`, values);
        message.success("Warehouse added successfully!");
        onSubmit(response.data);
      }
      setOpen(false); // Close the drawer after submission
    } catch (err) {
      console.error(err);
      message.error(err.response?.data?.message || "Failed to process the request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={isEdit ? "Edit Warehouse" : "Add Warehouse"}
      width={450}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
    >
      <Form layout="vertical" form={form} onFinish={onFinish} autoComplete="off">
        {/* Hidden field for the warehouse ID when editing */}
        {isEdit && (
          <Form.Item name="id" hidden>
            <Input type="hidden" />
          </Form.Item>
        )}

        <Form.Item
          label="Warehouse Name"
          name="name"
          rules={[{ required: true, message: "Please enter the warehouse name." }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Location (Address)"
          name={["location", "address"]}
          rules={[{ required: true, message: "Please enter the address." }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Pincode"
          name={["location", "pincode"]}
          rules={[{ required: true, message: "Please enter the pincode." }]}
        >
          <Input />
        </Form.Item>


        <Form.Item
          label="Capacity"
          name="capacity"
          rules={[{ required: true, message: "Please enter the capacity." }]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

        {/* <Form.Item
          label="Current Stock"
          name="currentStock"
          rules={[{ required: true, message: "Please enter the current stock." }]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item> */}

        <Form.Item>
          <Button
            type="primary"
            block
            htmlType="submit"
            loading={isLoading}
          >
            {isEdit ? "Update Warehouse" : "Add Warehouse"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default WarehouseDrawer;
